import { render, staticRenderFns } from "./orderPaySuccess.vue?vue&type=template&id=033a1303&"
import script from "./orderPaySuccess.vue?vue&type=script&lang=js&"
export * from "./orderPaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports